module.exports = __webpack_public_path__ + "media/images/Group 1-02958a670a59a6f787dbf47df6ca3d16.svg";